import { Routes } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';


export const routes: Routes = [
  { path: 'oauth/callback', pathMatch: 'full', redirectTo: '/home' },
  {
    path: 'view',
    canActivate: [autoLoginPartialRoutesGuard],
    loadComponent: () => import('./component/view-entry/view-entry.component').then(m => m.ViewEntryComponent)
  },
  {
    path: '',
    canActivate: [autoLoginPartialRoutesGuard],
    loadComponent: () => import('./component/authenticated-shell/authenticated-shell.component').then(m => m.AuthenticatedShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        // Keep legacy deep links like `/#/?...` working by normalizing them to `/search`.
        redirectTo: ({ queryParams }) => Object.keys(queryParams ?? {}).length > 0 ? 'search' : 'home'
      },
      {
        path: 'home',
        loadComponent: () => import('./component/home/home.component').then(m => m.HomeComponent)
      },
      {
        path: 'search',
        loadComponent: () => import('./component/search-result/search-result.component').then(m => m.SearchResultComponent)
      }
    ]
  },
  { path: '**', redirectTo: 'home' }
];

